import React, { PropTypes } from "react";
import CpdLiveItem from "components/CpdLocker/CpdLiveItem";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import moment from "moment";
import storage from "services/storage.js";
import { Link } from "react-router";

const { LIVE_WEBINARS } = constants;

const {
  loadUsersWebinarsSaga,
  cleanUsersWebinars,
  loadWebinarsAvailableYearsSaga,
} = actions;

class CpdLive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isMobile: !window.matchMedia("(min-width: 800px)").matches,
      activeYear: new Date().getFullYear(),
    };
  }

  componentWillMount() {
    // console.log(this.state);
    // this.props.loadWebinars(this.state.page);
    this.props.loadWebinars(this.state.page, this.state.activeYear);
    this.props.loadYearsWebinars();
  }

  nextPage = () => {
    this.setState(
      {
        ...this.state,
        page: this.state.page + 1,
      },
      () => {
        this.props.loadWebinars(this.state.page, this.state.activeYear);
      }
    );
  };
  onYearClick = (year) => {
    this.setState({
      page: 1,
      activeYear: year,
    });
    this.props.loadWebinars(1, year);
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  render() {
    const token = storage.getSessionData().session.token;
    const { int_cpds, ext_cpds, from, to } = this.props.cpds || {};
    return (
      <div>
        <div className="container_tabs col s12">
          <ul className="tabs cpd_tabs">
            <li className="tab">
              <Link activeClassName={"active"} to="/cpd/live">
                Live Meetings
              </Link>
            </li>
            <li className="tab">
              <Link activeClassName={"active"} to="/cpd/recorded">
                On-Demand Meetings
              </Link>
            </li>
          </ul>
        </div>
        <div id="live" className="main_live col s12">
          {!this.props.webinars.length && (
            <div className="has_no_items">No webinars currently available</div>
          )}
          {this.props.years.map((year) => (
            <button
              className="button_classic-years"
              onClick={() => this.onYearClick(year)}
            >
              {year}
            </button>
          ))}
          <p className="live_total">
            {from &&
              to &&
              `CPD Year: ${moment(from).format("MMMM YY")} – ${moment(
                to
              ).format("MMMM YY")}`}
            <br />
            {ext_cpds && <span>{`Ext CPD Points Total: ${ext_cpds}`}</span>}
            {ext_cpds && <br />}
            {int_cpds && <span>Int CPD Points Total: {int_cpds}</span>}
          </p>
          <div className="container_recorded">
            {this.props.webinars.map((webinar) => (
              <CpdLiveItem
                webinar={webinar}
                token={token}
                isMobile={this.state.isMobile}
              />
            ))}
          </div>
          {this.props.pages > this.state.page && (
            <a
              className="more_item"
              href="javascript:void(0)"
              onClick={this.nextPage}
            >
              LOAD MORE
            </a>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  webinarsYears: state.webinars.userWebinarsAvailableYears,
  webinars: state.webinars.usersWebinars[LIVE_WEBINARS].values,
  pages: state.webinars.usersWebinars[LIVE_WEBINARS].pages,
  cpds: state.webinars.usersWebinars[LIVE_WEBINARS].cpds,
  years: state.webinars.usersWebinars[LIVE_WEBINARS].years || [],
});
const mapDispatchToProps = (dispatch) => ({
  loadWebinars: (page, year) =>
    dispatch(loadUsersWebinarsSaga(LIVE_WEBINARS, page, year)),
  cleanWebinars: () => dispatch(cleanUsersWebinars()),
  loadYearsWebinars: () => dispatch(loadWebinarsAvailableYearsSaga()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CpdLive);



// WEBPACK FOOTER //
// ./src/containers/CpdLocker/CpdLive.js